import classNames from 'classnames';

import { Dialog, Spinner } from '@revelio/ui';

import { ModalDownloadButton } from './ModalDownloadButton';
import styles from './pdf-preview-modal.module.css';
import modalStyles from './themedModal.module.css';

export type PdfPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  previewUrl?: string;
  downloadUrl?: string;
};

export const PdfPreviewModal = ({
  isOpen,
  onClose,
  title,
  previewUrl,
  downloadUrl,
}: PdfPreviewModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={title}
      size="6xl"
      placement="top"
      className={classNames(modalStyles.content, styles.dialog)}
      bodyClassName={styles.body}
    >
      {downloadUrl && <ModalDownloadButton downloadUrl={downloadUrl} />}
      {previewUrl ? (
        <object data={previewUrl} type="application/pdf">
          <p>
            Your browser does not support PDFs.
            <a href={previewUrl}>Download the PDF</a> to view it.
          </p>
        </object>
      ) : (
        <Spinner />
      )}
    </Dialog>
  );
};
